export default "__VITE_ASSET__CqXntHs$__"